export interface ProposedDoc {
  path: string;
  content: string;
}

// Blocos de doc usam 4 crases (pra conter blocos de código de 3 crases dentro).
const DOC_RE = /````\s*bugpilot-doc\s+path=([^\n]+)\n([\s\S]*?)\n?````/g;

/** Extrai os blocos `bugpilot-doc` (path + markdown) e devolve o texto sem eles. */
export function parseDocBlocks(text: string): { docs: ProposedDoc[]; stripped: string } {
  const docs: ProposedDoc[] = [];
  let m: RegExpExecArray | null;
  const re = new RegExp(DOC_RE.source, 'g');
  while ((m = re.exec(text)) !== null) {
    const path = (m[1] ?? '').trim();
    const content = (m[2] ?? '').trim();
    if (path && content) docs.push({ path, content });
  }
  const stripped = text.replace(new RegExp(DOC_RE.source, 'g'), '').trim();
  return { docs, stripped };
}
